const init = () => {
	document.addEventListener('DOMContentLoaded', function () {
		const $slider = jQuery('.card-slider');
		// Helper function to manage custom center and active classes
		function updateCustomClasses(slick, targetIndex) {
			const slideCount = slick.slideCount;
			const slidesToShow = slick.options.slidesToShow;
			const half = Math.max(1, Math.floor(slidesToShow / 2));
			const activeIndices = [];

			for (let i = -half; i <= half; i++) {
				let idx = (targetIndex + i) % slideCount;
				if (idx < 0) idx += slideCount;
				activeIndices.push(idx);
			}

			$slider
				.find('.slick-slide')
				.removeClass('custom-center custom-active');

			$slider.find('.slick-slide').each(function () {
				const index = parseInt(jQuery(this).attr('data-slick-index'));
				let normalizedIndex = index % slideCount;

				if (normalizedIndex < 0) {
					normalizedIndex += slideCount;
				}

				if (normalizedIndex === targetIndex) {
					jQuery(this).addClass('custom-center');
				}

				if (activeIndices.includes(normalizedIndex)) {
					jQuery(this).addClass('custom-active');
				}
			});
		}
		$slider.on('init', function (event, slick) {
			updateCustomClasses(slick, 0);
		});
		$slider.on(
			'beforeChange',
			function (event, slick, currentSlide, nextSlide) {
				updateCustomClasses(slick, nextSlide);
			},
		);
		$slider.slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: '120px',
			arrows: true,
			dots: false,

			prevArrow: `
				<button class="slick-prev icon-bg filled">
					<span class="slick-left"></span>
				</button>`,
			nextArrow: `
				<button class="slick-next icon-bg filled">
					<span class="slick-right"></span>
				</button>`,
			responsive: [
				{
					breakpoint: 1920,
					settings: {
						centerPadding: '0px',
						slidesToShow: 3,
						variableWidth: false,
						centerMode: true,
					},
				},
				{
					breakpoint: 1440,
					settings: {
						centerPadding: '0px',
						slidesToShow: 3,
						variableWidth: true,
						centerMode: false,
					},
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						centerPadding: '0px',
						variableWidth: true,
						centerMode: false,
					},
				},
				{
					breakpoint: 768,
					settings: {
						centerMode: false,
						centerPadding: '0px',
						variableWidth: true,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						centerMode: false,
						centerPadding: '0px',
						variableWidth: true,
					},
				},
			],
		});
	});
};

export { init };
